export default __webpack_public_path__ + "static/media/Group84.64016c04.svg";